import { render, staticRenderFns } from "./Awards.vue?vue&type=template&id=550626cc&"
import script from "./Awards.vue?vue&type=script&lang=ts&"
export * from "./Awards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports